import React from 'react';
import CustomScrollTopMenu from './CustomScrollTopMenu';
import TopMenuAccountInfo from './TopMenuAccountInfo';
import { Logo } from '@vt/vt-ui';

const TopPanel = () => {
  return (
    <div className="menu-top justify-between relative px-6">
      <div className="fixed top-0 w-full h-2 sidebar-draggable" />
      <div className="flex w-full">
        <a
          href={window.electron?.isApp ? `#` : `/`}
          className="sidebar-draggable flex w-[40px] relative">
          <div className="absolute w-full h-full hover:bg-[#26131353] bg-transparent transition-all" />
          <span className="m-auto">
            <Logo variant={'withoutBg'} />
          </span>
        </a>
        <CustomScrollTopMenu />
      </div>
      <TopMenuAccountInfo />
    </div>
  );
};

export default TopPanel;
